module.exports = __webpack_public_path__ + "static/media/data.4b15b896.png";